import { useEffect, useState, type ReactNode } from "react";

/** As long as the fold takes to move in base.css (.fold). */
const MOVE_MS = 220;

interface Props {
  /** Shown, or folded away. */
  open: boolean;
  id?: string;
  children: ReactNode;
}

/**
 * Something that folds away smoothly and comes back the same way. Folded, it stays what it was (a form
 * keeps what was typed and what it looked up), but it cannot be seen, reached with Tab or read aloud.
 *
 * While it moves, its content is cut at its edge. Standing open it is not: a list that opens below a
 * field reaches beyond it.
 */
export function Fold({ open, id, children }: Props) {
  const [was, setWas] = useState(open);
  const [moving, setMoving] = useState(false);
  if (was !== open) {
    setWas(open);
    setMoving(true);
  }

  // a timer says the move is over, so it also ends where nothing moves (less motion, an older browser)
  useEffect(() => {
    if (!moving) return;
    const timer = setTimeout(() => {
      setMoving(false);
    }, MOVE_MS + 30);
    return () => {
      clearTimeout(timer);
    };
  }, [moving, open]);

  return (
    <div id={id} className={`fold${open ? "" : " shut"}${moving ? " moving" : ""}`} inert={!open}>
      <div>{children}</div>
    </div>
  );
}
